import React from "react";
import { useTranslation } from "react-i18next";

export const TeamStandingsHeader = (props: {
	teamStandingsFilter?: string | undefined;
}) => {
	const { t } = useTranslation();

	return (
		<thead className="table__head table__head--borderless table--stand__head">
			<tr className="table__head__row table__row">
				<th className="table__head__cell table__cell table--stand__cell u-pad--right--3 u-type--center">
					<span>#</span>
				</th>

				<th className="table__head__cell table__cell table--stand__cell table--stand__grow">
					<span>
						{t("EVENT.STATISTICS.TEAM_STANDINGS.HEADER.TEAM")}
					</span>
				</th>

				<th className="table__head__cell table__cell table--stand__cell table--stand__med">
				</th>

				{(props.teamStandingsFilter === "full" ||
					props.teamStandingsFilter === "short") && (
					<th className="table__head__cell table__cell table--stand__cell">
						<span>
							{t(
								"EVENT.STATISTICS.TEAM_STANDINGS.HEADER.MATCHES_PLAYED"
							)}
						</span>
					</th>
				)}

				{(props.teamStandingsFilter === "last_five" ||
					!props.teamStandingsFilter) && (
					<th className="table__head__cell table__cell table--stand__cell table--stand__xxlrg">
						<span>
							{t("EVENT.STATISTICS.TEAM_STANDINGS.HEADER.LAST_5")}
						</span>
					</th>
				)}

				{props.teamStandingsFilter === "full" ||
				!props.teamStandingsFilter ? (
					<>
						<th className="table__head__cell table__cell table--stand__cell">
							<span>
								{t(
									"EVENT.STATISTICS.TEAM_STANDINGS.HEADER.WINS"
								)}
							</span>
						</th>

						<th className="table__head__cell table__cell table--stand__cell">
							<span>
								{t(
									"EVENT.STATISTICS.TEAM_STANDINGS.HEADER.DRAWS"
								)}
							</span>
						</th>

						<th className="table__head__cell table__cell table--stand__cell">
							<span>
								{t(
									"EVENT.STATISTICS.TEAM_STANDINGS.HEADER.LOSSES"
								)}
							</span>
						</th>

						<th className="table__head__cell table__cell table--stand__cell table--stand__med">
							<span>
								{t(
									"EVENT.STATISTICS.TEAM_STANDINGS.HEADER.GOALS"
								)}
							</span>
						</th>
					</>
				) : null}

				{(props.teamStandingsFilter === "short" ||
					!props.teamStandingsFilter) && (
					<th className="table__head__cell table__cell table--stand__cell table--stand__med">
						<span>
							{t(
								"EVENT.STATISTICS.TEAM_STANDINGS.HEADER.DIFFERENCE"
							)}
						</span>
					</th>
				)}

				{(props.teamStandingsFilter !== "last_five" ||
					!props.teamStandingsFilter) && (
					<th className="table__head__cell table__cell table--stand__cell table--stand__sml">
						<span>
							{t("EVENT.STATISTICS.TEAM_STANDINGS.HEADER.POINTS")}
						</span>
					</th>
				)}
			</tr>
		</thead>
	);
};
